//-------------------------------------------------------------------------------------
//
//	GfxApp3D
//
//		
//
//-------------------------------------------------------------------------------------

//-------------------------------------------------------------------------------------
//	Imports
//-------------------------------------------------------------------------------------
import { GfxApp } from "./GfxApp.js";
import { Transform, Projection3D } from "../../VectorUtilsJS/src/VectorUtilLib.js";
import { GfxDrawing, GfxPath } from "./GfxDrawing.js";
import { GfxRender } from "./GfxRender.js";
import { GfxRender3D } from "./GfxRender3D.js";

//=====================================================================================
//
//	GfxApp3D
//
//	gfxAppInfo = {
//		name: "[appName]", 
//		defaultSettings = {}, 
//		controlGroups = [], 
//		appConfig = {}
//	}
//=====================================================================================

function GfxApp3D(gfxAppInfo = {})
{
	GfxApp.call(this, gfxAppInfo);
	
	this.appConfig.display3D = true;
}

GfxApp3D.prototype = Object.create(GfxApp.prototype);

Object.defineProperty(GfxApp3D.prototype, 'constructor', {
	value: GfxApp3D,
	enumerable: false,
	write: true });


//-------------------------------------------------------------------------------------
//	Render To Context
//
//		Overridden to handle 3D projection
//-------------------------------------------------------------------------------------
GfxApp3D.prototype.RenderToContext = function(context, viewTransform, viewProjection)
{
	if (this.gfxDrawing != undefined)
		GfxRender3D.RenderGfxDrawing(context, this.gfxDrawing, viewTransform, viewProjection);
}

//-------------------------------------------------------------------------------------
//	Render To SVG
//
//		Overridden to handle 3D projection (-- not yet working --)
//-------------------------------------------------------------------------------------
GfxApp3D.prototype.RenderToSVG = function(gfxAppData = undefined)
{
	var svg = undefined;
	
	if (this.gfxDrawing != undefined)
		svg = GfxRender.RenderGfxDrawingToSVG(this.gfxDrawing, gfxAppData);
		
	return svg;
}


//-------------------------------------------------------------------------------------
//	Public
//-------------------------------------------------------------------------------------
export { GfxApp3D };

